"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenesisState = exports.mimir = exports.lastChainHeight = void 0;
/* eslint-disable */
var long_1 = __importDefault(require("long"));
var minimal_1 = __importDefault(require("protobufjs/minimal"));
var type_network_1 = require("../../../../thorchain/v1/x/thorchain/types/type_network");
var type_pool_1 = require("../../../../thorchain/v1/x/thorchain/types/type_pool");
var type_liquidity_provider_1 = require("../../../../thorchain/v1/x/thorchain/types/type_liquidity_provider");
var type_observed_tx_1 = require("../../../../thorchain/v1/x/thorchain/types/type_observed_tx");
var type_tx_out_1 = require("../../../../thorchain/v1/x/thorchain/types/type_tx_out");
var type_node_account_1 = require("../../../../thorchain/v1/x/thorchain/types/type_node_account");
var type_vault_1 = require("../../../../thorchain/v1/x/thorchain/types/type_vault");
var type_reserve_contributor_1 = require("../../../../thorchain/v1/x/thorchain/types/type_reserve_contributor");
var msg_swap_1 = require("../../../../thorchain/v1/x/thorchain/types/msg_swap");
var type_network_fee_1 = require("../../../../thorchain/v1/x/thorchain/types/type_network_fee");
var type_chain_contract_1 = require("../../../../thorchain/v1/x/thorchain/types/type_chain_contract");
var type_thorname_1 = require("../../../../thorchain/v1/x/thorchain/types/type_thorname");
function createBaselastChainHeight() {
    return { chain: "", height: long_1.default.ZERO };
}
exports.lastChainHeight = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.chain !== "") {
            writer.uint32(10).string(message.chain);
        }
        if (!message.height.isZero()) {
            writer.uint32(16).int64(message.height);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaselastChainHeight();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chain = reader.string();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            chain: isSet(object.chain) ? String(object.chain) : "",
            height: isSet(object.height) ? long_1.default.fromString(object.height) : long_1.default.ZERO,
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.chain !== undefined && (obj.chain = message.chain);
        message.height !== undefined &&
            (obj.height = (message.height || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaselastChainHeight();
        message.chain = (_a = object.chain) !== null && _a !== void 0 ? _a : "";
        message.height =
            object.height !== undefined && object.height !== null
                ? long_1.default.fromValue(object.height)
                : long_1.default.ZERO;
        return message;
    },
};
function createBasemimir() {
    return { key: "", value: long_1.default.ZERO };
}
exports.mimir = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (!message.value.isZero()) {
            writer.uint32(16).int64(message.value);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBasemimir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? String(object.key) : "",
            value: isSet(object.value) ? long_1.default.fromString(object.value) : long_1.default.ZERO,
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = (message.value || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial: function (object) {
        var _a;
        var message = createBasemimir();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? long_1.default.fromValue(object.value)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseGenesisState() {
    return {
        pools: [],
        liquidityProviders: [],
        observedTxInVoters: [],
        observedTxOutVoters: [],
        txOuts: [],
        nodeAccounts: [],
        vaults: [],
        reserve: long_1.default.UZERO,
        lastSignedHeight: long_1.default.ZERO,
        lastChainHeights: [],
        reserveContributors: [],
        network: undefined,
        msgSwaps: [],
        networkFees: [],
        chainContracts: [],
        THORNames: [],
        mimirs: [],
        storeVersion: long_1.default.ZERO,
        bondProviders: [],
    };
}
exports.GenesisState = {
    encode: function (message, writer) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e, e_6, _f, e_7, _g, e_8, _h, e_9, _j, e_10, _k, e_11, _l, e_12, _m, e_13, _o, e_14, _p, e_15, _q;
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        try {
            for (var _r = __values(message.pools), _s = _r.next(); !_s.done; _s = _r.next()) {
                var v = _s.value;
                type_pool_1.Pool.encode(v, writer.uint32(10).fork()).ldelim();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_a = _r.return)) _a.call(_r);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _t = __values(message.liquidityProviders), _u = _t.next(); !_u.done; _u = _t.next()) {
                var v = _u.value;
                type_liquidity_provider_1.LiquidityProvider.encode(v, writer.uint32(18).fork()).ldelim();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_u && !_u.done && (_b = _t.return)) _b.call(_t);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var _v = __values(message.observedTxInVoters), _w = _v.next(); !_w.done; _w = _v.next()) {
                var v = _w.value;
                type_observed_tx_1.ObservedTxVoter.encode(v, writer.uint32(26).fork()).ldelim();
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_w && !_w.done && (_c = _v.return)) _c.call(_v);
            }
            finally { if (e_3) throw e_3.error; }
        }
        try {
            for (var _x = __values(message.observedTxOutVoters), _y = _x.next(); !_y.done; _y = _x.next()) {
                var v = _y.value;
                type_observed_tx_1.ObservedTxVoter.encode(v, writer.uint32(34).fork()).ldelim();
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_y && !_y.done && (_d = _x.return)) _d.call(_x);
            }
            finally { if (e_4) throw e_4.error; }
        }
        try {
            for (var _z = __values(message.txOuts), _0 = _z.next(); !_0.done; _0 = _z.next()) {
                var v = _0.value;
                type_tx_out_1.TxOut.encode(v, writer.uint32(42).fork()).ldelim();
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_0 && !_0.done && (_e = _z.return)) _e.call(_z);
            }
            finally { if (e_5) throw e_5.error; }
        }
        try {
            for (var _1 = __values(message.nodeAccounts), _2 = _1.next(); !_2.done; _2 = _1.next()) {
                var v = _2.value;
                type_node_account_1.NodeAccount.encode(v, writer.uint32(50).fork()).ldelim();
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_2 && !_2.done && (_f = _1.return)) _f.call(_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        try {
            for (var _3 = __values(message.vaults), _4 = _3.next(); !_4.done; _4 = _3.next()) {
                var v = _4.value;
                type_vault_1.Vault.encode(v, writer.uint32(58).fork()).ldelim();
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_4 && !_4.done && (_g = _3.return)) _g.call(_3);
            }
            finally { if (e_7) throw e_7.error; }
        }
        if (!message.reserve.isZero()) {
            writer.uint32(64).uint64(message.reserve);
        }
        if (!message.lastSignedHeight.isZero()) {
            writer.uint32(80).int64(message.lastSignedHeight);
        }
        try {
            for (var _5 = __values(message.lastChainHeights), _6 = _5.next(); !_6.done; _6 = _5.next()) {
                var v = _6.value;
                exports.lastChainHeight.encode(v, writer.uint32(90).fork()).ldelim();
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_6 && !_6.done && (_h = _5.return)) _h.call(_5);
            }
            finally { if (e_8) throw e_8.error; }
        }
        try {
            for (var _7 = __values(message.reserveContributors), _8 = _7.next(); !_8.done; _8 = _7.next()) {
                var v = _8.value;
                type_reserve_contributor_1.ReserveContributor.encode(v, writer.uint32(98).fork()).ldelim();
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_8 && !_8.done && (_j = _7.return)) _j.call(_7);
            }
            finally { if (e_9) throw e_9.error; }
        }
        if (message.network !== undefined) {
            type_network_1.Network.encode(message.network, writer.uint32(106).fork()).ldelim();
        }
        try {
            for (var _9 = __values(message.msgSwaps), _10 = _9.next(); !_10.done; _10 = _9.next()) {
                var v = _10.value;
                msg_swap_1.MsgSwap.encode(v, writer.uint32(154).fork()).ldelim();
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_10 && !_10.done && (_k = _9.return)) _k.call(_9);
            }
            finally { if (e_10) throw e_10.error; }
        }
        try {
            for (var _11 = __values(message.networkFees), _12 = _11.next(); !_12.done; _12 = _11.next()) {
                var v = _12.value;
                type_network_fee_1.NetworkFee.encode(v, writer.uint32(162).fork()).ldelim();
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_12 && !_12.done && (_l = _11.return)) _l.call(_11);
            }
            finally { if (e_11) throw e_11.error; }
        }
        try {
            for (var _13 = __values(message.chainContracts), _14 = _13.next(); !_14.done; _14 = _13.next()) {
                var v = _14.value;
                type_chain_contract_1.ChainContract.encode(v, writer.uint32(178).fork()).ldelim();
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (_14 && !_14.done && (_m = _13.return)) _m.call(_13);
            }
            finally { if (e_12) throw e_12.error; }
        }
        try {
            for (var _15 = __values(message.THORNames), _16 = _15.next(); !_16.done; _16 = _15.next()) {
                var v = _16.value;
                type_thorname_1.THORName.encode(v, writer.uint32(186).fork()).ldelim();
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_16 && !_16.done && (_o = _15.return)) _o.call(_15);
            }
            finally { if (e_13) throw e_13.error; }
        }
        try {
            for (var _17 = __values(message.mimirs), _18 = _17.next(); !_18.done; _18 = _17.next()) {
                var v = _18.value;
                exports.mimir.encode(v, writer.uint32(194).fork()).ldelim();
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (_18 && !_18.done && (_p = _17.return)) _p.call(_17);
            }
            finally { if (e_14) throw e_14.error; }
        }
        if (!message.storeVersion.isZero()) {
            writer.uint32(200).int64(message.storeVersion);
        }
        try {
            for (var _19 = __values(message.bondProviders), _20 = _19.next(); !_20.done; _20 = _19.next()) {
                var v = _20.value;
                type_node_account_1.BondProviders.encode(v, writer.uint32(210).fork()).ldelim();
            }
        }
        catch (e_15_1) { e_15 = { error: e_15_1 }; }
        finally {
            try {
                if (_20 && !_20.done && (_q = _19.return)) _q.call(_19);
            }
            finally { if (e_15) throw e_15.error; }
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseGenesisState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pools.push(type_pool_1.Pool.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.liquidityProviders.push(type_liquidity_provider_1.LiquidityProvider.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.observedTxInVoters.push(type_observed_tx_1.ObservedTxVoter.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.observedTxOutVoters.push(type_observed_tx_1.ObservedTxVoter.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.txOuts.push(type_tx_out_1.TxOut.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.nodeAccounts.push(type_node_account_1.NodeAccount.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.vaults.push(type_vault_1.Vault.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.reserve = reader.uint64();
                    break;
                case 10:
                    message.lastSignedHeight = reader.int64();
                    break;
                case 11:
                    message.lastChainHeights.push(exports.lastChainHeight.decode(reader, reader.uint32()));
                    break;
                case 12:
                    message.reserveContributors.push(type_reserve_contributor_1.ReserveContributor.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.network = type_network_1.Network.decode(reader, reader.uint32());
                    break;
                case 19:
                    message.msgSwaps.push(msg_swap_1.MsgSwap.decode(reader, reader.uint32()));
                    break;
                case 20:
                    message.networkFees.push(type_network_fee_1.NetworkFee.decode(reader, reader.uint32()));
                    break;
                case 22:
                    message.chainContracts.push(type_chain_contract_1.ChainContract.decode(reader, reader.uint32()));
                    break;
                case 23:
                    message.THORNames.push(type_thorname_1.THORName.decode(reader, reader.uint32()));
                    break;
                case 24:
                    message.mimirs.push(exports.mimir.decode(reader, reader.uint32()));
                    break;
                case 25:
                    message.storeVersion = reader.int64();
                    break;
                case 26:
                    message.bondProviders.push(type_node_account_1.BondProviders.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools)
                ? object.pools.map(function (e) { return type_pool_1.Pool.fromJSON(e); })
                : [],
            liquidityProviders: Array.isArray(object === null || object === void 0 ? void 0 : object.liquidityProviders)
                ? object.liquidityProviders.map(function (e) {
                    return type_liquidity_provider_1.LiquidityProvider.fromJSON(e);
                })
                : [],
            observedTxInVoters: Array.isArray(object === null || object === void 0 ? void 0 : object.observedTxInVoters)
                ? object.observedTxInVoters.map(function (e) { return type_observed_tx_1.ObservedTxVoter.fromJSON(e); })
                : [],
            observedTxOutVoters: Array.isArray(object === null || object === void 0 ? void 0 : object.observedTxOutVoters)
                ? object.observedTxOutVoters.map(function (e) {
                    return type_observed_tx_1.ObservedTxVoter.fromJSON(e);
                })
                : [],
            txOuts: Array.isArray(object === null || object === void 0 ? void 0 : object.txOuts)
                ? object.txOuts.map(function (e) { return type_tx_out_1.TxOut.fromJSON(e); })
                : [],
            nodeAccounts: Array.isArray(object === null || object === void 0 ? void 0 : object.nodeAccounts)
                ? object.nodeAccounts.map(function (e) { return type_node_account_1.NodeAccount.fromJSON(e); })
                : [],
            vaults: Array.isArray(object === null || object === void 0 ? void 0 : object.vaults)
                ? object.vaults.map(function (e) { return type_vault_1.Vault.fromJSON(e); })
                : [],
            reserve: isSet(object.reserve)
                ? long_1.default.fromString(object.reserve)
                : long_1.default.UZERO,
            lastSignedHeight: isSet(object.lastSignedHeight)
                ? long_1.default.fromString(object.lastSignedHeight)
                : long_1.default.ZERO,
            lastChainHeights: Array.isArray(object === null || object === void 0 ? void 0 : object.lastChainHeights)
                ? object.lastChainHeights.map(function (e) { return exports.lastChainHeight.fromJSON(e); })
                : [],
            reserveContributors: Array.isArray(object === null || object === void 0 ? void 0 : object.reserveContributors)
                ? object.reserveContributors.map(function (e) {
                    return type_reserve_contributor_1.ReserveContributor.fromJSON(e);
                })
                : [],
            network: isSet(object.network)
                ? type_network_1.Network.fromJSON(object.network)
                : undefined,
            msgSwaps: Array.isArray(object === null || object === void 0 ? void 0 : object.msgSwaps)
                ? object.msgSwaps.map(function (e) { return msg_swap_1.MsgSwap.fromJSON(e); })
                : [],
            networkFees: Array.isArray(object === null || object === void 0 ? void 0 : object.networkFees)
                ? object.networkFees.map(function (e) { return type_network_fee_1.NetworkFee.fromJSON(e); })
                : [],
            chainContracts: Array.isArray(object === null || object === void 0 ? void 0 : object.chainContracts)
                ? object.chainContracts.map(function (e) { return type_chain_contract_1.ChainContract.fromJSON(e); })
                : [],
            THORNames: Array.isArray(object === null || object === void 0 ? void 0 : object.THORNames)
                ? object.THORNames.map(function (e) { return type_thorname_1.THORName.fromJSON(e); })
                : [],
            mimirs: Array.isArray(object === null || object === void 0 ? void 0 : object.mimirs)
                ? object.mimirs.map(function (e) { return exports.mimir.fromJSON(e); })
                : [],
            storeVersion: isSet(object.storeVersion)
                ? long_1.default.fromString(object.storeVersion)
                : long_1.default.ZERO,
            bondProviders: Array.isArray(object === null || object === void 0 ? void 0 : object.bondProviders)
                ? object.bondProviders.map(function (e) { return type_node_account_1.BondProviders.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pools) {
            obj.pools = message.pools.map(function (e) { return (e ? type_pool_1.Pool.toJSON(e) : undefined); });
        }
        else {
            obj.pools = [];
        }
        if (message.liquidityProviders) {
            obj.liquidityProviders = message.liquidityProviders.map(function (e) {
                return e ? type_liquidity_provider_1.LiquidityProvider.toJSON(e) : undefined;
            });
        }
        else {
            obj.liquidityProviders = [];
        }
        if (message.observedTxInVoters) {
            obj.observedTxInVoters = message.observedTxInVoters.map(function (e) {
                return e ? type_observed_tx_1.ObservedTxVoter.toJSON(e) : undefined;
            });
        }
        else {
            obj.observedTxInVoters = [];
        }
        if (message.observedTxOutVoters) {
            obj.observedTxOutVoters = message.observedTxOutVoters.map(function (e) {
                return e ? type_observed_tx_1.ObservedTxVoter.toJSON(e) : undefined;
            });
        }
        else {
            obj.observedTxOutVoters = [];
        }
        if (message.txOuts) {
            obj.txOuts = message.txOuts.map(function (e) { return (e ? type_tx_out_1.TxOut.toJSON(e) : undefined); });
        }
        else {
            obj.txOuts = [];
        }
        if (message.nodeAccounts) {
            obj.nodeAccounts = message.nodeAccounts.map(function (e) {
                return e ? type_node_account_1.NodeAccount.toJSON(e) : undefined;
            });
        }
        else {
            obj.nodeAccounts = [];
        }
        if (message.vaults) {
            obj.vaults = message.vaults.map(function (e) { return (e ? type_vault_1.Vault.toJSON(e) : undefined); });
        }
        else {
            obj.vaults = [];
        }
        message.reserve !== undefined &&
            (obj.reserve = (message.reserve || long_1.default.UZERO).toString());
        message.lastSignedHeight !== undefined &&
            (obj.lastSignedHeight = (message.lastSignedHeight || long_1.default.ZERO).toString());
        if (message.lastChainHeights) {
            obj.lastChainHeights = message.lastChainHeights.map(function (e) {
                return e ? exports.lastChainHeight.toJSON(e) : undefined;
            });
        }
        else {
            obj.lastChainHeights = [];
        }
        if (message.reserveContributors) {
            obj.reserveContributors = message.reserveContributors.map(function (e) {
                return e ? type_reserve_contributor_1.ReserveContributor.toJSON(e) : undefined;
            });
        }
        else {
            obj.reserveContributors = [];
        }
        message.network !== undefined &&
            (obj.network = message.network
                ? type_network_1.Network.toJSON(message.network)
                : undefined);
        if (message.msgSwaps) {
            obj.msgSwaps = message.msgSwaps.map(function (e) {
                return e ? msg_swap_1.MsgSwap.toJSON(e) : undefined;
            });
        }
        else {
            obj.msgSwaps = [];
        }
        if (message.networkFees) {
            obj.networkFees = message.networkFees.map(function (e) {
                return e ? type_network_fee_1.NetworkFee.toJSON(e) : undefined;
            });
        }
        else {
            obj.networkFees = [];
        }
        if (message.chainContracts) {
            obj.chainContracts = message.chainContracts.map(function (e) {
                return e ? type_chain_contract_1.ChainContract.toJSON(e) : undefined;
            });
        }
        else {
            obj.chainContracts = [];
        }
        if (message.THORNames) {
            obj.THORNames = message.THORNames.map(function (e) {
                return e ? type_thorname_1.THORName.toJSON(e) : undefined;
            });
        }
        else {
            obj.THORNames = [];
        }
        if (message.mimirs) {
            obj.mimirs = message.mimirs.map(function (e) { return (e ? exports.mimir.toJSON(e) : undefined); });
        }
        else {
            obj.mimirs = [];
        }
        message.storeVersion !== undefined &&
            (obj.storeVersion = (message.storeVersion || long_1.default.ZERO).toString());
        if (message.bondProviders) {
            obj.bondProviders = message.bondProviders.map(function (e) {
                return e ? type_node_account_1.BondProviders.toJSON(e) : undefined;
            });
        }
        else {
            obj.bondProviders = [];
        }
        return obj;
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var message = createBaseGenesisState();
        message.pools = ((_a = object.pools) === null || _a === void 0 ? void 0 : _a.map(function (e) { return type_pool_1.Pool.fromPartial(e); })) || [];
        message.liquidityProviders =
            ((_b = object.liquidityProviders) === null || _b === void 0 ? void 0 : _b.map(function (e) { return type_liquidity_provider_1.LiquidityProvider.fromPartial(e); })) ||
                [];
        message.observedTxInVoters =
            ((_c = object.observedTxInVoters) === null || _c === void 0 ? void 0 : _c.map(function (e) { return type_observed_tx_1.ObservedTxVoter.fromPartial(e); })) ||
                [];
        message.observedTxOutVoters =
            ((_d = object.observedTxOutVoters) === null || _d === void 0 ? void 0 : _d.map(function (e) { return type_observed_tx_1.ObservedTxVoter.fromPartial(e); })) ||
                [];
        message.txOuts = ((_e = object.txOuts) === null || _e === void 0 ? void 0 : _e.map(function (e) { return type_tx_out_1.TxOut.fromPartial(e); })) || [];
        message.nodeAccounts =
            ((_f = object.nodeAccounts) === null || _f === void 0 ? void 0 : _f.map(function (e) { return type_node_account_1.NodeAccount.fromPartial(e); })) || [];
        message.vaults = ((_g = object.vaults) === null || _g === void 0 ? void 0 : _g.map(function (e) { return type_vault_1.Vault.fromPartial(e); })) || [];
        message.reserve =
            object.reserve !== undefined && object.reserve !== null
                ? long_1.default.fromValue(object.reserve)
                : long_1.default.UZERO;
        message.lastSignedHeight =
            object.lastSignedHeight !== undefined && object.lastSignedHeight !== null
                ? long_1.default.fromValue(object.lastSignedHeight)
                : long_1.default.ZERO;
        message.lastChainHeights =
            ((_h = object.lastChainHeights) === null || _h === void 0 ? void 0 : _h.map(function (e) { return exports.lastChainHeight.fromPartial(e); })) || [];
        message.reserveContributors =
            ((_j = object.reserveContributors) === null || _j === void 0 ? void 0 : _j.map(function (e) {
                return type_reserve_contributor_1.ReserveContributor.fromPartial(e);
            })) || [];
        message.network =
            object.network !== undefined && object.network !== null
                ? type_network_1.Network.fromPartial(object.network)
                : undefined;
        message.msgSwaps =
            ((_k = object.msgSwaps) === null || _k === void 0 ? void 0 : _k.map(function (e) { return msg_swap_1.MsgSwap.fromPartial(e); })) || [];
        message.networkFees =
            ((_l = object.networkFees) === null || _l === void 0 ? void 0 : _l.map(function (e) { return type_network_fee_1.NetworkFee.fromPartial(e); })) || [];
        message.chainContracts =
            ((_m = object.chainContracts) === null || _m === void 0 ? void 0 : _m.map(function (e) { return type_chain_contract_1.ChainContract.fromPartial(e); })) || [];
        message.THORNames =
            ((_o = object.THORNames) === null || _o === void 0 ? void 0 : _o.map(function (e) { return type_thorname_1.THORName.fromPartial(e); })) || [];
        message.mimirs = ((_p = object.mimirs) === null || _p === void 0 ? void 0 : _p.map(function (e) { return exports.mimir.fromPartial(e); })) || [];
        message.storeVersion =
            object.storeVersion !== undefined && object.storeVersion !== null
                ? long_1.default.fromValue(object.storeVersion)
                : long_1.default.ZERO;
        message.bondProviders =
            ((_q = object.bondProviders) === null || _q === void 0 ? void 0 : _q.map(function (e) { return type_node_account_1.BondProviders.fromPartial(e); })) || [];
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
